import messages from './i18n/permissions_notice_messages'
import PermissionsNotice from './components/PermissionsNotice'

export default function () {
  return { component: PermissionsNotice, messages }
}
